import { css } from '@emotion/css';
import {
  AlignContent,
  BorderRadius,
  ColorConstant,
  Display,
  FlexDirection,
  Font,
  FontWeight,
  JustifyContent,
  Spacing,
} from 'src/styles';

export const section = css`
  border: none;
  box-shadow: 0rem 0.25rem 1rem rgba(2, 85, 163, 0.15);
  ${Spacing.p24}
  ${Spacing.my24}
  ${BorderRadius.xs}
`;

export const header = (hasTitle: boolean) => css`
  ${Display.flex}
  ${AlignContent.center}
  ${hasTitle ? JustifyContent.spaceBetween : JustifyContent.end}
`;

export const title = css`
  ${FontWeight.bold}
  ${Font.h2}
  color: ${ColorConstant.GRAY8};
  ${Display.flex}
  ${FlexDirection.column}
`;
